import React from 'react';
import { Draft, Extra, Service, VehicleSize } from '../../types/booking';
import { duration, euro, longDate, timeRange } from '../../utils/format';
type Props = {
  draft: Draft;
  service: Service | null;
  chosenExtras: Extra[];
  size: VehicleSize | null;
  price: {
    base: number;
    extras: number;
    surcharge: number;
    amount: number;
    minutes: number;
  };
  deposit: number;
};
export function Summary({
  draft,
  service,
  chosenExtras,
  size,
  price,
  deposit
}: Props) {
  return <aside className="lg:sticky lg:top-28" data-id="element-493" data-mp="29dfl5gxcii23">
      <div className="overflow-hidden rounded-2xl border border-edge bg-carbon" data-id="element-494" data-mp="24fnpqcxhsdt5">
        {service && <img src={service.image} alt="" aria-hidden="true" className="h-28 w-full object-cover" data-id="element-495" data-mp="1zinkg48gvf33" />}
        <div className="p-6" data-id="element-496" data-mp="1ujkqbeu0yt9w">
          <h2 className="text-xs uppercase tracking-[0.2em] text-dim" data-id="element-497" data-mp="1ukcbdvpzx8lx">Uw boeking</h2>

          <dl className="mt-5 space-y-3.5 text-sm" data-id="element-498" data-mp="3tuc068mivloj">
            <div className="flex justify-between gap-4" data-id="element-499" data-mp="3owsdqlfo82li">
              <dt className="text-dim" data-id="element-500" data-mp="3oxbvo25bmqzj">Behandeling</dt>
              <dd className="text-right font-medium text-chalk" data-id="element-501" data-mp="25nxviapflosc">{service?.name ?? '—'}</dd>
            </div>
            <div className="flex justify-between gap-4" data-id="element-502" data-mp="2anu1gfhovqaj">
              <dt className="text-dim" data-id="element-503" data-mp="2al7mhusgy8ia">Voertuig</dt>
              <dd className="text-right font-medium text-chalk" data-id="element-504" data-mp="1vrcq3o9i2bnz">{size?.label ?? '—'}</dd>
            </div>
            <div className="flex justify-between gap-4" data-id="element-505" data-mp="20q5w6vmgj0e4">
              <dt className="text-dim" data-id="element-506" data-mp="2of8nywat29mc">Extra's</dt>
              <dd className="text-right font-medium text-chalk" data-id="element-507" data-mp="2ofh02lz3tawh">
                {chosenExtras.length > 0 ? chosenExtras.map(e => e.name).join(', ') : '—'}
              </dd>
            </div>
            <div className="flex justify-between gap-4" data-id="element-508" data-mp="2eomcnea4g59g">
              <dt className="text-dim" data-id="element-509" data-mp="2jnql22p81yyq">Wanneer</dt>
              <dd className="text-right font-medium text-chalk" data-id="element-510" data-mp="2jmfj88fc71a9">
                {draft.date && draft.time ? <>
                    <span className="block capitalize" data-id="element-511" data-mp="3c49o7w9hiegj">{longDate(draft.date)}</span>
                    <span className="mt-0.5 block font-normal text-dim" data-id="element-512" data-mp="3c6e47cknr3x6">
                      {timeRange(draft.time, price.minutes)}
                    </span>
                  </> : '—'}
              </dd>
            </div>
            <div className="flex justify-between gap-4" data-id="element-513" data-mp="3cy0mhv4m45bg">
              <dt className="text-dim" data-id="element-514" data-mp="381jxyzti3oxu">Duur</dt>
              <dd className="text-right font-medium text-chalk" data-id="element-515" data-mp="382v1qzmy4woy">
                {price.minutes > 0 ? duration(price.minutes) : '—'}
              </dd>
            </div>
          </dl>

          {service && <dl className="mt-5 space-y-2 border-t border-edge pt-5 text-sm" data-id="element-516" data-mp="2y94g02i7f0cy">
              <div className="flex justify-between gap-4" data-id="element-517" data-mp="2tc4absp9nzmd">
                <dt className="text-dim" data-id="element-518" data-mp="2pb2956bshdhr">{service.name}</dt>
                <dd className="text-chalk" data-id="element-519" data-mp="2p8g1z7st9002">{euro(price.base)}</dd>
              </div>
              {price.extras > 0 && <div className="flex justify-between gap-4" data-id="element-520" data-mp="2fbjpkqzsjtq8">
                  <dt className="text-dim" data-id="element-521" data-mp="2fe68fms4tvnr">Extra's</dt>
                  <dd className="text-chalk" data-id="element-522" data-mp="uuu4uz3qe6ro">{euro(price.extras)}</dd>
                </div>}
              {price.surcharge > 0 && <div className="flex justify-between gap-4" data-id="element-523" data-mp="zv890627owkf">
                  <dt className="text-dim" data-id="element-524" data-mp="14tjlkojw5l6c">Toeslag {size?.label}</dt>
                  <dd className="text-chalk" data-id="element-525" data-mp="18ubvlk0l7u3o">{euro(price.surcharge)}</dd>
                </div>}
            </dl>}

          <div className="mt-5 flex items-end justify-between border-t border-edge pt-5" data-id="element-526" data-mp="c4uk2oexbdu2">
            <span className="text-sm text-dim" data-id="element-527" data-mp="h3fj4kifvrgx">Totaal</span>
            <span className="font-display text-3xl font-extrabold tracking-tight text-ember" data-id="element-528" data-mp="l4hl393qqhml">
              {euro(price.amount)}
            </span>
          </div>

          {draft.paymentMethod === 'deposit' && price.amount > 0 && <p className="mt-3 text-xs leading-relaxed text-dim" data-id="element-529" data-mp="3pheaf8uguoo3">
              Nu online: <span className="font-medium text-chalk" data-id="element-530" data-mp="3tjj7khk4i3fh">{euro(deposit)}</span> aanbetaling. Rest na de
              behandeling.
            </p>}
        </div>
      </div>

      <p className="mt-4 px-1 text-xs leading-relaxed text-dim" data-id="element-531" data-mp="35gcpju4yvwgg">
        Gratis annuleren tot 24 uur voor uw afspraak. Prijzen inclusief btw.
      </p>
    </aside>;
}